import React from "react";

export default function WhyChooseUs() {
  // from-purple-500 via-pink-500 to-red-500
  return (
    <div className="bg-gradient-to-r rounded-lg shadow-lg mx-5 my-5">
   <div className="w-full my-8 p-6 bg-white rounded-lg shadow-md">
  <h2 className="text-center text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
    Why Choose Us..
  </h2>
</div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Industry Expertise */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-poppins text-center font-bold text-purple-600">
          Industry Expertise
        </h3>
        <p className="text-gray-800 text-center mt-2">
          Our team’s deep knowledge and experience across various sectors enable us to deliver targeted and effective solutions.
        </p>
      </div>
      {/* Tailored Solutions */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-poppins text-center font-bold text-pink-600">
          Tailored Solutions
        </h3>
        <p className="text-gray-800 text-center mt-2">
          We customize our services to meet the specific needs of each client, ensuring that our solutions are always aligned with your business goals.
        </p>
      </div>
      {/* Commitment to Quality */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-poppins text-center font-bold text-red-600">
          Commitment to Quality
        </h3>
        <p className="text-gray-800 text-center mt-2">
          We adhere to the highest standards of service and quality, consistently exceeding client expectations.
        </p>
      </div>
      {/* Dedicated Support */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-poppins text-center font-bold text-indigo-600">
          Dedicated Support
        </h3>
        <p className="text-gray-800 text-center mt-2">
          Our focus on personalized service ensures that we are always responsive and proactive in addressing your needs.
        </p>
      </div>
    </div>
  </div>
  
  );
}
